import { GameState } from '../shared/state'

// Signature FNV-1a du terrain (contenu + dimensions). Elle change dès qu'UNE case change — creusage,
// repousse, explosion, éboulement, ouverture de porte — parce que la sim écrit ces changements dans
// `s.terrain`. C'est le déclencheur d'invalidation du cache de rendu du terrain (render.ts) : même
// terrain -> même hash -> canvas hors-écran réutilisé ; terrain modifié -> hash différent -> repeint.
// PUR (aucun accès DOM) pour être testable en Node (vitest).
export function terrainHash(s: Pick<GameState, 'terrain' | 'cols' | 'rows'>): number {
  const t = s.terrain
  let h = 2166136261 >>> 0
  h = Math.imul(h ^ s.cols, 16777619)
  h = Math.imul(h ^ s.rows, 16777619)
  for (let i = 0; i < t.length; i++) h = Math.imul(h ^ t[i]!, 16777619)
  return h >>> 0
}
